<template>
  <a name="details" id="details"></a>
  <div class="row" v-if="activity.thumbnailImageUrl" >
    <img :src="activity.thumbnailImageUrl" :alt="activity.displayName" class="img-max">
  </div>
  <div class="row mt-3">
    <div class="col-sm-8 pl-0">
      <h3>{{ activity.displayName }}</h3>
    </div>  
    <div class="col-sm-4">
        <span class="activityMetaLabel" v-if="activity.duration">Duration</span> <span class="activityAdditionalInfo">{{ activity.duration }}</span>
    </div>
  </div>
  <div v-if="schedule.schedules && schedule.schedules.length" class="row showtimes">
    <div class="col-sm-2">
      <strong>When</strong>
    </div>
    <div class="col-sm-10">
      <span class="mr-3" v-for="timeSchedule in schedule.schedules" :key="timeSchedule.sortKey">
       <span v-if="timeSchedule.prependText" class="activityMetaLabel">{{timeSchedule.prependText}}</span> {{ timeSchedule.displayStart }} <span v-if="timeSchedule.displayEnd">&mdash; {{ timeSchedule.displayEnd }}</span> <span v-if="timeSchedule.appendText" class="activityMetaLabel">{{timeSchedule.appendText}}</span>
      </span>
    </div>
  </div>
  <p v-html="activity.shortDescription"></p>
  <div>
    <a :href="activity.activityUrl">{{ moreDetailsCTA }} <i class="fa fa-chevron-right"></i></a>
  </div>
  <div class="mt-5 w-100 text-center mobile-only">
    <a @click="backToTimes()" style="color: #4a4a4a;text-decoration: underline;font-weight:normal;"><em>Back to times</em></a>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject, computed, toRef } from 'vue';
import CalendarAppParam from "../composables/application-parameter";
import * as CalendarModel from "../composables/calendar-model";
import * as ContentModel from "../composables/calendar-content-model";

export default defineComponent({
  props: {
    activity: { type: Object as () => ContentModel.CalendarActivityContent, required: true },
    schedule: { type: Object as () => CalendarModel.ActivityDayScheduleDto, required: true }
  },
  setup(props) {
    // Static Properties
    const appParam = inject(CalendarAppParam)!;
    // Reactive Properties

    // Data setup

    // Events
    const backToTimes = function() {
      document.getElementById('times-list')?.scrollIntoView({ behavior: "smooth" });
    }

    // Queries

    // Reactions

    // return Model
    return {
      moreDetailsCTA: appParam?.moreDetailsCTA,
      purchaseCTAName: appParam?.purchaseCTAName,
      purchaseCTAUrl: appParam?.purchaseCTAUrl,
      backToTimes
    }
  }
});

</script>
